import { apiDomain as api, apiKey } from '../appConfig';
import { systemId } from '../entraConfig';

const userLogin = async (accessToken) => {
	const response = await fetch(`${api}/service/SRTAPP/api/SRTAPP/SRTAPP002_S02`, {
		method: 'POST',
		body: JSON.stringify({
			ACCESSTOKEN: accessToken,
			SYSID: systemId,
		}),
		headers: {
			'Content-Type': 'application/json',
			'Ocp-Apim-Subscription-Key': apiKey,
		},
	});

	if (!response.ok) {
		throw new Error(`User login failed with status ${response.status}`);
	}

	return response.json();
};

export default userLogin;



// WEBPACK FOOTER //
// ./src/js/fetch/userLogin.js